<div class='container'>

  <mat-card>

   <div class="content">

      <img style="width: 200px; margin: auto;" src="assets/images/geral/logo_azul.png">

      <form class="form" name="userFormAuth" [formGroup]='userFormAuth' autocomplete="off">

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" [errorStateMatcher]="matcher" [formControl]="userFormAuth.controls.email"
             autocomplete="off">
          <mat-error
            *ngIf="userFormAuth.controls.email.hasError('email') && !userFormAuth.controls.email.hasError('required')">
            Email inválido
          </mat-error>
          <mat-error *ngIf="userFormAuth.controls.email.hasError('required')">
            Email é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
           <mat-label>Senha</mat-label>
          <input matInput type="password" [errorStateMatcher]="matcher" [formControl]="userFormAuth.controls.password"
            autocomplete="off">
          <mat-error *ngIf="userFormAuth.controls.password.hasError('required')">
            Senha é obrigatório
          </mat-error>
        </mat-form-field>

        <div class="forgotPassword">
          <a href="#" routerLink="/forgot-password">Esqueceu a senha?</a>
        </div>

        <div class="forgotPassword">
          <a href="#" routerLink="/member-login">
            << Voltar</a>
        </div>

      </form>
    </div>

    <mat-dialog-actions fxLayoutAlign="flex-end" flex justify-content='flex-end'>
      <button mat-raised-button [disabled]="userFormAuth.invalid"
        (click)="authService.SignIn(userFormAuth.controls.email.value, userFormAuth.controls.password.value)">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
    </mat-dialog-actions>

  </mat-card>

</div>